import { useTypedSelector } from ".";

export const useIsMultiTenant = (): boolean =>
  useTypedSelector(state => !!state.setting.localConfig?.multi_tenant);
